import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../state-management/rootReducer';

const initialState: Invitation[] = [];

export const invitationSlice = createSlice({
  name: 'invitations',
  initialState: initialState,
  reducers: {
    setInvitations: (
      state: Invitation[] = [],
      action: PayloadAction<Invitation[]>
    ) => {
      return [...action.payload];
    },
    removeInvitation: (
      state: Invitation[] = [],
      action: PayloadAction<string>
    ) => {
      return state.filter((invitation) => invitation.id !== action.payload);
    },
  },
});

export const { setInvitations, removeInvitation } = invitationSlice.actions;

export const getInvitations = (state: RootState) => state.invitations;

export default invitationSlice.reducer;
